import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpErrorService } from '../http-error.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CameraSnapshotReferenceRequestService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService) {

    }

  requestManyLogs(deviceIds: string[]) {
      const url = this.configService.API_URI + '/CamerasSnapshotReference/RequestMany';
      const req = new HttpRequest('POST', url, deviceIds);

      return this.http.request(req).pipe(
        map((res) => {
          if (res instanceof HttpResponse) {
            return res;
          }
        }),
        catchError((err) => {
          this.httpErrorService.handleHttpError(err);
          return of(err);
        })
      );
  }

  /**
   * Asks each asset to throw away its reference images and re-create them. The new images are not
   * requested as part of this - they are picked up by the next scheduled reference request.
   */
  resetMany(deviceIds: string[]) {
      const url = this.configService.API_URI + '/CamerasSnapshotReference/ResetMany';
      const req = new HttpRequest('POST', url, deviceIds);

      return this.http.request(req).pipe(
        map((res) => {
          if (res instanceof HttpResponse) {
            return res;
          }
        }),
        catchError((err) => {
          this.httpErrorService.handleHttpError(err);
          return of(err);
        })
      );
  }
}
